import { render } from "./page-header-content.vue?vue&type=template&id=866b0d50&ts=true"
import script from "./page-header-content.vue?vue&type=script&lang=ts"
export * from "./page-header-content.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__